import type { CSSProperties } from 'react';

import { Box, type BoxProps } from '@frontend/components';

import { SHADOW_REGION_TO_GRID_AREA_MAP } from './const';
import type { ShadowPlacement, ShadowRegion } from './types';
import { getBoxShadow } from './util';

type WithShadowPlacementOrBoxShadow =
  | { shadowPlacement: ShadowPlacement | ShadowPlacement[]; boxShadow?: never }
  | { boxShadow: string; shadowPlacement?: never };

type WithShadowRegionOrGridArea =
  | { shadowRegion: ShadowRegion; gridArea?: never }
  | { gridArea: string; shadowRegion?: never };

export type ShadowProps = BoxProps & {
  depth?: number;
  sx?: CSSProperties;
} & WithShadowPlacementOrBoxShadow &
  WithShadowRegionOrGridArea;

export const Shadow = ({
  shadowPlacement,
  boxShadow: boxShadowProp,
  shadowRegion,
  gridArea: gridAreaProp,
  depth = 1,
  sx,
  ...restProps
}: ShadowProps) => {
  const boxShadow = boxShadowProp ?? getBoxShadow(shadowPlacement);
  const gridArea = gridAreaProp ?? SHADOW_REGION_TO_GRID_AREA_MAP[shadowRegion];

  return (
    <Box
      boxSize="100%"
      gridArea={gridArea}
      boxShadow={boxShadow}
      sx={{
        '--blur': `calc(${depth} * var(--depth-unit))`,
        ...sx,
      }}
      {...restProps}
    />
  );
};
